import React, {useContext, useRef, useState} from "react";
import {createPortal} from "react-dom";
import {LoadingIcon, SuccessIcon, ErrorIcon} from './icons'

const canUseDOM = !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
);

const LoadingContext = React.createContext({
    showLoading(...rest:any){},
    hideLoading(...rest:any){},
    showSuccess(...rest:any){},
    showError(...rest:any){}
});
const { Provider } = LoadingContext;

type LoadingType = 'loading' | 'success' | 'error'

export interface LoadingItemProps {
    type: LoadingType,
    text?: string,
    status: boolean
}

export interface addLoading {
    text?: string,
}


const Loading: React.FC<LoadingItemProps> = (props) => {
    if (props.type === 'loading') {
        return <div className='loader c-b'>
            <LoadingIcon/>
            <p className='c-b-t'>{props.text || '加载中'}</p>
        </div>
    } else if (props.type === 'success') {
        return <div className='success c-b'>
            <SuccessIcon/>
            <p className='c-b-t'>{props.text || '操作成功'}</p>
        </div>
    } else if (props.type === 'error') {
        return <div className='error c-b'>
            <ErrorIcon/>
            <p className='c-b-t'>{props.text || '操作失败'}</p>
        </div>
    }
    return null
}

const LoadingContainer: React.FC<LoadingItemProps> = (props) => {
    if (props.status) {
        return <div className='loading-mask'>
            <Loading {...props}/>
        </div>
    }
    return null
}


export const LoadingProvider: React.FC = (props) => {

    const [show, setShow] = useState<boolean>(false)
    const [loadingType, setLoadingType] = useState<LoadingType>('loading')
    const [text, setText] = useState<string>('')
    const timer = useRef<null | number>(null)

    const showLoading = (text: string = '') => {
        setShow(true)
        setLoadingType('loading')
        setText(text)
    }

    const hideLoading = () => {
        setText('')
        setShow(false)
    }

    const showSuccess = (text: string = '',callback= () => {},wait = 2000) => {
        setShow(true)
        setLoadingType('success')
        setText(text)

        if(timer.current){
            clearTimeout(timer.current)
        }
        timer.current = setTimeout(() => {
            setShow(false)
            callback()
        },wait)
    }

    const showError = (text: string = '',callback= () => {},wait = 2000) => {
        setShow(true)
        setLoadingType('error')
        setText(text)

        if(timer.current){
            clearTimeout(timer.current)
        }

        timer.current = setTimeout(() => {
            setShow(false)
            callback()
        },wait)
    }


    const portalTarget = canUseDOM ? document.body : null;

    return <Provider value={{showLoading, hideLoading, showSuccess, showError}}>
        {props.children}
        {
            portalTarget && createPortal(
                <LoadingContainer status={show} type={loadingType} text={text}/>,
                portalTarget
            )
        }
    </Provider>
}

export const useLoading = () => {
    const ctx = useContext(LoadingContext)

    if(!ctx){
        throw Error('The `useToasts` hook must be called from a descendent of the `ToastProvider`.');
    }

    return {
        showLoading:ctx.showLoading,
        hideLoading:ctx.hideLoading,
        showSuccess:ctx.showSuccess,
        showError:ctx.showError
    }

}
